import { createSelector } from "@reduxjs/toolkit";

export const selectDiscoveryState = (state) => state.discovery;

export const selectThemes = (state) => state.discovery.themes;

export const selectConfig = createSelector(
  [selectDiscoveryState],
  (discovery) => discovery.config
);

export const selectConfigLoading = createSelector(
  [selectConfig],
  (config) => config?.loading
);

export const selectDocuments = (state) =>
  state.discovery.themes[0]?.Documents || [];

export const selectOccurrences = (state) =>
  state.discovery.themes[0]?.Occurrences || 0;

export const selectContent = (state) => state.discovery.content;

export const selectSnapshots = (state) => state.discovery.snapshots;

export const selectAddToDictPanel = (state) => state.discovery.addToDictPanel;
